import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function CookieRichtlinie() {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Update page title
    document.title = "Cookie-Richtlinie | reputrust.ai";
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-600 selection:bg-tron-primary/30 selection:text-[#0F172A]">
      <Header />

      <div className="pt-32 pb-20 relative overflow-hidden">
        {/* Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-96 h-96 bg-tron-primary/10 rounded-full blur-[100px] animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-tron-secondary/10 rounded-full blur-[100px] animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>

        {/* Content */}
        <div className="max-w-[900px] mx-auto px-6 relative z-10">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200">
            <h1 className="text-3xl md:text-4xl font-bold text-[#0F172A] mb-8 border-b border-slate-200 pb-6" style={{ fontFamily: 'Inter Tight, sans-serif' }}>
              Cookie-Richtlinie
            </h1>

            <div className="prose prose-slate prose-lg max-w-none" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Was sind Cookies?</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Cookies sind kleine Textdateien, die von Websites verwendet werden, um die Benutzererfahrung effizienter zu gestalten.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                Laut Gesetz können wir Cookies auf Ihrem Gerät speichern, wenn diese für den Betrieb dieser Seite unbedingt notwendig sind. Für alle anderen Cookie-Typen benötigen wir Ihre Erlaubnis.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                Diese Seite verwendet unterschiedliche Cookie-Typen. Einige Cookies werden von Drittparteien platziert, die auf unseren Seiten erscheinen.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Wie wir Cookies verwenden</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien anbieten zu können und die Zugriffe auf unsere Website zu analysieren. Außerdem geben wir Informationen zu Ihrer Verwendung unserer Website an unsere Partner für soziale Medien, Werbung und Analysen weiter. Unsere Partner führen diese Informationen möglicherweise mit weiteren Daten zusammen, die Sie ihnen bereitgestellt haben oder die sie im Rahmen Ihrer Nutzung der Dienste gesammelt haben.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Arten von Cookies</h2>

              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-[#0F172A] mb-2">Notwendige Cookies</h3>
                  <p className="text-slate-600 leading-relaxed">
                    Notwendige Cookies helfen dabei, eine Website nutzbar zu machen, indem sie Grundfunktionen wie Seitennavigation und Zugriff auf sichere Bereiche der Website ermöglichen. Die Website kann ohne diese Cookies nicht richtig funktionieren.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-[#0F172A] mb-2">Präferenz-Cookies</h3>
                  <p className="text-slate-600 leading-relaxed">
                    Präferenz-Cookies ermöglichen einer Website, sich an Informationen zu erinnern, die die Art beeinflussen, wie sich eine Website verhält oder aussieht, wie z. B. Ihre bevorzugte Sprache oder die Region, in der Sie sich befinden.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-[#0F172A] mb-2">Statistik-Cookies</h3>
                  <p className="text-slate-600 leading-relaxed">
                    Statistik-Cookies helfen Website-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-[#0F172A] mb-2">Marketing-Cookies</h3>
                  <p className="text-slate-600 leading-relaxed">
                    Marketing-Cookies werden verwendet, um Besuchern auf Webseiten zu folgen. Die Absicht ist, Anzeigen zu zeigen, die relevant und ansprechend für den einzelnen Benutzer sind und daher wertvoller für Publisher und werbetreibende Drittparteien sind.
                  </p>
                </div>
              </div>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Cookie-Einstellungen ändern</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Sie können Ihre Einwilligung jederzeit auf unserer Website ändern oder widerrufen.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                Bitte geben Sie Ihre Einwilligungs-ID und das Datum an, wenn Sie uns bezüglich Ihrer Einwilligung kontaktieren.
              </p>

              <p className="text-slate-600 leading-relaxed mb-4 mt-8">
                <strong className="text-[#0F172A]">Stand: Februar 2026</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
